module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order",
    style: (_vm.bannerFlag ? 'margin-top: 56px;' : '')
  }, [_c('div', {
    staticClass: "order-box w",
    staticStyle: {
      "min-height": "calc(100vh - 125px)"
    }
  }, [_c('div', {
    staticClass: "order-step"
  }, _vm._l((_vm.stepList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "order-step-wrap",
      class: _vm.currentStep === item.step ? 'step-active' : ''
    }, [_c('i', {
      class: item.icon,
      staticStyle: {
        "font-size": "18px"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "calc(100vh - 220px)"
    },
    attrs: {
      "element-loading-text": "加载中...",
      "element-loading-background": "rgba(0, 0, 0, 0)"
    }
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n        " + _vm._s(_vm.form.demName) + " " + _vm._s(_vm.catalogTitle) + " "), (_vm.currentStep != 1 && _vm.form.demPatient) ? _c('span', [_vm._v("【" + _vm._s(_vm.form.demPatient) + "】")]) : _vm._e()]), _vm._v(" "), (_vm.currentStep === 1) ? _c('div', {
    staticClass: "order-detail-catalog",
    staticStyle: {
      "min-height": "calc(100vh - 313px)"
    }
  }, [_c('section', {
    staticClass: "order-catalog"
  }, [_c('ul', {
    staticClass: "box"
  }, _vm._l((_vm.catalogList), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "content",
      class: _vm.currentCatalog === i ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.changeMainCatalog(i)
        }
      }
    }, [(_vm.currentCatalog === i) ? _c('img', {
      staticClass: "i",
      attrs: {
        "src": item.iconSelect
      }
    }) : _c('img', {
      staticClass: "i",
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('a', {
      staticClass: "cover-link"
    })])
  }), 0)]), _vm._v(" "), _c('section', {
    staticClass: "order-sub-catalog"
  }, [_c('ul', {
    staticClass: "box"
  }, _vm._l((_vm.subCatalogList), function(item, j) {
    return _c('li', {
      key: j,
      staticClass: "content",
      class: _vm.currentSubCatalog === j ? 'active' : '',
      attrs: {
        "id": _vm.currentCatalog == 0 && _vm.user.demServType != '00' ? 'clinic' : 'factory'
      },
      on: {
        "click": function($event) {
          return _vm.changeSubCatalog(j)
        }
      }
    }, [_c('div', {
      staticClass: "sub-box"
    }, [_c('img', {
      staticClass: "i",
      attrs: {
        "src": item.icon
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('a', {
      staticClass: "cover-link"
    })])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.currentStep === 2 && _vm.subCatalogId != '3010130') ? _c('div', {
    staticClass: "order-detail-design",
    staticStyle: {
      "min-height": "calc(100vh - 313px)"
    }
  }, [_c('div', {
    staticClass: "order-basic-wrap"
  }, [_c('base-tag', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label": "基本信息"
    }
  }), _vm._v(" "), (_vm.common.serv.get(_vm.subCatalogId).isTooth == '1') ? _c('y-tooth', {
    attrs: {
      "singleDataList": _vm.singleDataList,
      "bridgeDataList": _vm.bridgeDataList,
      "subCatalogId": _vm.subCatalogId,
      "servBridge": _vm.servBridge,
      "isCreate": _vm.isCreate,
      "options1": _vm.options1,
      "options2": _vm.options2,
      "options3": _vm.options3,
      "flagBridge": _vm.flagBridge
    },
    on: {
      "select-tooth": _vm.changeOrderCount,
      "flagChange": _vm.judgeJaw,
      "sendBridge": _vm.sendBridge,
      "checkChange": _vm.checkChange
    }
  }) : _vm._e(), _vm._v(" "), _c('input-field', {
    attrs: {
      "inputClass": "contact",
      "label": '下单名称',
      "customStyle": {
        '--inputColorContact': _vm.colorContact
      },
      "readonly": _vm.user.demServType == '00' ? true : false,
      "required": ""
    },
    on: {
      "input": _vm.change1
    },
    model: {
      value: (_vm.form.demContact),
      callback: function($$v) {
        _vm.$set(_vm.form, "demContact", $$v)
      },
      expression: "form.demContact"
    }
  }), _vm._v(" "), _c('input-field', {
    attrs: {
      "inputClass": "phone",
      "label": "联系方式",
      "customStyle": {
        '--inputColorPhone': _vm.colorPhone
      },
      "readonly": false,
      "required": ""
    },
    on: {
      "input": _vm.change2
    },
    model: {
      value: (_vm.form.demPhone),
      callback: function($$v) {
        _vm.$set(_vm.form, "demPhone", $$v)
      },
      expression: "form.demPhone"
    }
  }), _vm._v(" "), _c('input-field', {
    attrs: {
      "inputClass": "patient",
      "label": "患者姓名",
      "customStyle": {
        '--inputColorPatient': _vm.colorPatient
      },
      "readonly": false,
      "required": ""
    },
    on: {
      "input": _vm.change3
    },
    model: {
      value: (_vm.form.demPatient),
      callback: function($$v) {
        _vm.$set(_vm.form, "demPatient", $$v)
      },
      expression: "form.demPatient"
    }
  }), _vm._v(" "), _c('select-field', {
    attrs: {
      "label": "患者性别",
      "options": _vm.demSexMap,
      "placeholder": "请选择性别",
      "required": ""
    },
    model: {
      value: (_vm.form.demSex),
      callback: function($$v) {
        _vm.$set(_vm.form, "demSex", $$v)
      },
      expression: "form.demSex"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "设计费详情"
    }
  }), _vm._v(" "), _c('input-field', {
    attrs: {
      "label": _vm.subCatalogId == '1010410' ? '桥架数量' : '数量',
      "readonly": true,
      "inputClass": _vm.rowFactory ? 'factory' : '',
      "required": ""
    },
    model: {
      value: (_vm.form.orderCount),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderCount", $$v)
      },
      expression: "form.orderCount"
    }
  }), _vm._v(" "), _c('input-field', {
    attrs: {
      "label": "单价",
      "readonly": true,
      "inputClass": _vm.rowFactory ? 'factory' : '',
      "required": ""
    },
    model: {
      value: (_vm.form.orderPrice),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderPrice", $$v)
      },
      expression: "form.orderPrice"
    }
  }), _vm._v(" "), (_vm.fund > 0) ? _c('input-field', {
    attrs: {
      "label": "基台数量",
      "readonly": true,
      "required": ""
    },
    model: {
      value: (_vm.fund),
      callback: function($$v) {
        _vm.fund = $$v
      },
      expression: "fund"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fund > 0) ? _c('input-field', {
    attrs: {
      "label": "基台单价",
      "readonly": true,
      "required": ""
    },
    model: {
      value: (_vm.basePrice),
      callback: function($$v) {
        _vm.basePrice = $$v
      },
      expression: "basePrice"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.quantity > 0 && _vm.subCatalogId != '1010410') || (_vm.subCatalogId == '1010120' && (_vm.options2 == true || _vm.options3 == true)) ||
    (['1010210', '1010220'].includes(_vm.subCatalogId) && _vm.options1 == true)) ? _c('input-field', {
    attrs: {
      "label": _vm.subCatalogId !== '1010120' ? '上部冠数量' : '基台数量',
      "readonly": true,
      "inputClass": _vm.fund > 0 && _vm.quantity > 0 && _vm.user.demServType == '00' ? 'base' : '',
      "required": ""
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.quantity > 0 && _vm.subCatalogId != '1010410') || (_vm.subCatalogId == '1010120' && (_vm.options2 == true || _vm.options3 == true)) ||
    (['1010210', '1010220'].includes(_vm.subCatalogId) && _vm.options1 == true)) ? _c('input-field', {
    attrs: {
      "label": _vm.subCatalogId !== '1010120' ? '上部冠单价' : '基台单价',
      "readonly": true,
      "inputClass": _vm.fund > 0 && _vm.quantity > 0 && _vm.user.demServType == '00' ? 'base' : '',
      "required": ""
    },
    model: {
      value: (_vm.extraUnitPrice),
      callback: function($$v) {
        _vm.extraUnitPrice = $$v
      },
      expression: "extraUnitPrice"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLevel) ? _c('select-field', {
    attrs: {
      "label": "设计师级别",
      "options": _vm.desLevelMap,
      "placeholder": "请选择设计师级别",
      "inputClass": _vm.rowFactory || (_vm.fund > 0 && _vm.quantity > 0) ? 'factory' : ''
    },
    on: {
      "input": _vm.calAmount
    },
    model: {
      value: (_vm.form.desLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "desLevel", $$v)
      },
      expression: "form.desLevel"
    }
  }) : _vm._e(), _vm._v(" "), _c('input-number-field', {
    attrs: {
      "label": "是否加急(元)",
      "disabled": _vm.isEditServOrder == '1',
      "isEditServOrder": _vm.isEditServOrder,
      "inputClass": (_vm.rowFactory || (_vm.fund > 0 && _vm.quantity > 0)) && _vm.user.demServType == '00' ? 'factory' : '',
      "required": ""
    },
    on: {
      "input": _vm.calAmount
    },
    model: {
      value: (_vm.form.orderRushFee),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderRushFee", $$v)
      },
      expression: "form.orderRushFee"
    }
  }), _vm._v(" "), _c('input-field', {
    attrs: {
      "label": "总价",
      "readonly": true,
      "inputClass": (_vm.rowFactory || (_vm.fund > 0 && _vm.quantity > 0)) && _vm.user.demServType == '00' ? 'factory' : '',
      "required": ""
    },
    model: {
      value: (_vm.form.orderAmount),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderAmount", $$v)
      },
      expression: "form.orderAmount"
    }
  }), _vm._v(" "), (_vm.catalogId == '20') ? _c('radio-field', {
    staticStyle: {
      "width": "30%",
      "margin-left": "0.1%"
    },
    attrs: {
      "label": "口扫模型编辑",
      "oneText": "否",
      "twoText": _vm.editScanModelText,
      "required": ""
    },
    on: {
      "input": _vm.calAmount
    },
    model: {
      value: (_vm.form.isEditScanModel),
      callback: function($$v) {
        _vm.$set(_vm.form, "isEditScanModel", $$v)
      },
      expression: "form.isEditScanModel"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.subCatalogId == '1010120') ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "设计需求"
    }
  }), _vm._v(" "), (_vm.subCatalogId == '1010120') ? _c('div', {
    staticClass: "input-form-wrap-row el-select-input"
  }, [_vm._m(0), _vm._v(" "), _c('el-select', {
    staticClass: "input-form",
    attrs: {
      "placeholder": "请选择修复体材质",
      "size": "mini"
    },
    model: {
      value: (_vm.form.repairMaterial),
      callback: function($$v) {
        _vm.$set(_vm.form, "repairMaterial", $$v)
      },
      expression: "form.repairMaterial"
    }
  }, [_c('el-option', {
    staticClass: "option-item",
    attrs: {
      "label": "氧化锆",
      "value": "00"
    }
  }), _vm._v(" "), _c('el-option', {
    staticClass: "option-item",
    attrs: {
      "label": "玻璃陶瓷",
      "value": "01"
    }
  }), _vm._v(" "), _c('el-option', {
    staticClass: "option-item",
    attrs: {
      "label": "树脂",
      "value": "02"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.subCatalogId).isHole == '1') ? _c('div', {
    staticClass: "input-form-wrap",
    staticStyle: {
      "padding": "10px 0px",
      "width": "280px",
      "margin-left": "15px"
    },
    on: {
      "change": _vm.changePosHole
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-radio",
    staticStyle: {
      "width": "130px"
    }
  }, [_c('div', {
    staticClass: "input-radio-box"
  }, [_c('el-radio', {
    attrs: {
      "label": "0",
      "aria-label": "否"
    },
    model: {
      value: (_vm.form.posHole),
      callback: function($$v) {
        _vm.$set(_vm.form, "posHole", $$v)
      },
      expression: "form.posHole"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1",
      "aria-label": "是"
    },
    model: {
      value: (_vm.form.posHole),
      callback: function($$v) {
        _vm.$set(_vm.form, "posHole", $$v)
      },
      expression: "form.posHole"
    }
  }, [_vm._v("是")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.form.posHole == '1') ? _c('input-number-field', {
    staticStyle: {
      "line-height": "40px",
      "margin-left": "-10px"
    },
    attrs: {
      "label": "开孔直径",
      "required": "",
      "step": 0.1,
      "suffixText": 'mm'
    },
    model: {
      value: (_vm.form.holeDiameter),
      callback: function($$v) {
        _vm.$set(_vm.form, "holeDiameter", $$v)
      },
      expression: "form.holeDiameter"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.catalogId == '10' && _vm.subCatalogId != '1010698' && _vm.subCatalogId != '1010699' && _vm.subCatalogId != '1010700') ? _c('radio-field', {
    staticStyle: {
      "width": "27%",
      "padding": "10px 10px",
      "line-height": "40px",
      "margin-left": "-5px"
    },
    attrs: {
      "label": "口扫模型编辑",
      "oneText": "否",
      "twoText": _vm.editScanModelText,
      "required": ""
    },
    on: {
      "input": _vm.calAmount
    },
    model: {
      value: (_vm.form.isEditScanModel),
      callback: function($$v) {
        _vm.$set(_vm.form, "isEditScanModel", $$v)
      },
      expression: "form.isEditScanModel"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (['1010120', '1010210', '1010220'].includes(_vm.subCatalogId)) ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('SelIndication', {
    attrs: {
      "subCatalogId": _vm.subCatalogId,
      "currentStep": _vm.currentStep
    },
    on: {
      "handleIndication": _vm.handleIndication
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.quantity > 0 || (_vm.subCatalogId == '1010120' && (_vm.options2 == true || _vm.options3 == true)) ||
    (['1010210', '1010220'].includes(_vm.subCatalogId) && _vm.options1 == true)) ? _c('div', {
    staticClass: "order-input-wrap"
  }, [(_vm.subCatalogId == '1010210' || _vm.subCatalogId == '1010220') ? _c('base-tag', {
    attrs: {
      "label": "种植上部修复冠设计需求"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '1010120') ? _c('base-tag', {
    attrs: {
      "label": "基台设计需求"
    }
  }) : _vm._e(), _vm._v(" "), _c('ImpSys', {
    attrs: {
      "subCatalogId": _vm.subCatalogId,
      "catalogId": _vm.catalogId,
      "isEditServOrder": _vm.isEditServOrder,
      "designFlag": true,
      "orderDetail": _vm.form,
      "transmit": false
    },
    on: {
      "handleImp": _vm.handleImp
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.subCatalogId).isImpSystem == '1' && (_vm.subCatalogId != '1010120')) ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "种植体信息"
    }
  }), _vm._v(" "), _c('ImpSys', {
    attrs: {
      "subCatalogId": _vm.subCatalogId,
      "catalogId": _vm.catalogId,
      "isEditServOrder": _vm.isEditServOrder,
      "transmit": false,
      "orderDetail": _vm.form
    },
    on: {
      "handleImp": _vm.handleImp
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '1010698' || _vm.subCatalogId == '1010699') ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "器械规格"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap",
    staticStyle: {
      "margin-left": "-2%"
    }
  }, [_vm._m(2), _vm._v(" "), _c('el-input', {
    staticClass: "input-form",
    attrs: {
      "size": "mini",
      "placeholder": "请输入手术器械盒供应商"
    },
    model: {
      value: (_vm.form.surgicalBoxSupplier),
      callback: function($$v) {
        _vm.$set(_vm.form, "surgicalBoxSupplier", $$v)
      },
      expression: "form.surgicalBoxSupplier"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-form-wrap",
    staticStyle: {
      "margin-left": "-1%"
    }
  }, [_vm._m(3), _vm._v(" "), _c('el-input', {
    staticClass: "input-form",
    attrs: {
      "size": "mini",
      "placeholder": "请输入导环规格和型号"
    },
    model: {
      value: (_vm.form.plantModel),
      callback: function($$v) {
        _vm.$set(_vm.form, "plantModel", $$v)
      },
      expression: "form.plantModel"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "备注信息"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-textarea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 20
      },
      "placeholder": "请输入备注信息"
    },
    model: {
      value: (_vm.form.orderRemark),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderRemark", $$v)
      },
      expression: "form.orderRemark"
    }
  })], 1)], 1), _vm._v(" "), (_vm.remarkHistory.length != 0) ? _c('div', {
    staticClass: "order-input-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "快捷标签"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-history"
  }, _vm._l((_vm.remarkHistory), function(item, index) {
    return _c('el-tag', {
      key: index,
      staticStyle: {
        "margin": "5px 5px"
      },
      attrs: {
        "closable": ""
      },
      on: {
        "click": function($event) {
          return _vm.replaceStr(index)
        },
        "close": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.currentStep === 3) ? _c('div', {
    staticClass: "order-detail-upload",
    staticStyle: {
      "min-height": "calc(100vh - 313px)"
    }
  }, [(_vm.common.serv.get(_vm.subCatalogId).isDataType == '1' || _vm.common.serv.get(_vm.subCatalogId).isSoftType == '1' || (_vm.common.serv.get(_vm.subCatalogId).isDeviceType == '1' && (_vm.user.demServType == '10' || _vm.user.demServType == '11') && _vm.subCatalogId != '1010698' && _vm.subCatalogId != '1010699')) ? _c('div', {
    staticClass: "input-type-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "数据信息"
    }
  }), _vm._v(" "), (_vm.common.serv.get(_vm.subCatalogId).isDataType == '1') ? _c('div', {
    staticClass: "input-form-wrap"
  }, [_vm._m(4), _vm._v(" "), _c('el-select', {
    staticClass: "input-select",
    attrs: {
      "placeholder": "请选择数据类型",
      "size": "mini"
    },
    model: {
      value: (_vm.form.dataType),
      callback: function($$v) {
        _vm.$set(_vm.form, "dataType", $$v)
      },
      expression: "form.dataType"
    }
  }, _vm._l((_vm.common.dict.get('biz_scan_type')), function(item) {
    return _c('el-option', {
      key: item.value,
      staticClass: "option-item",
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.form.dataType == '99') ? _c('div', [_c('el-input', {
    staticClass: "input-form",
    attrs: {
      "placeholder": "请输入数据类型",
      "size": "mini"
    },
    model: {
      value: (_vm.form.otherDataType),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherDataType", $$v)
      },
      expression: "form.otherDataType"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.subCatalogId).isSoftType == '1') ? _c('div', {
    staticClass: "input-form-wrap"
  }, [_vm._m(5), _vm._v(" "), _c('el-select', {
    staticClass: "input-select",
    attrs: {
      "placeholder": "请选择软件种类",
      "size": "mini"
    },
    model: {
      value: (_vm.form.softType),
      callback: function($$v) {
        _vm.$set(_vm.form, "softType", $$v)
      },
      expression: "form.softType"
    }
  }, _vm._l((_vm.common.dict.get('biz_soft_type')), function(item) {
    return _c('el-option', {
      key: item.value,
      staticClass: "option-item",
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.form.softType == '99') ? _c('div', [_c('el-input', {
    staticClass: "input-form",
    attrs: {
      "placeholder": "请输入扫描仪品牌",
      "size": "mini"
    },
    model: {
      value: (_vm.form.otherSoftType),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherSoftType", $$v)
      },
      expression: "form.otherSoftType"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isDevicelistShow == true) ? _c('div', {
    staticClass: "input-form-wrap"
  }, [_vm._m(6), _vm._v(" "), _c('el-select', {
    staticClass: "input-select",
    attrs: {
      "placeholder": "请选择设备型号",
      "size": "mini"
    },
    on: {
      "change": function($event) {
        return _vm.changeDeviceType()
      }
    },
    model: {
      value: (_vm.form.deviceType),
      callback: function($$v) {
        _vm.$set(_vm.form, "deviceType", $$v)
      },
      expression: "form.deviceType"
    }
  }, _vm._l((_vm.devicelists), function(item) {
    return _c('el-option', {
      key: item.value,
      staticClass: "option-item",
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.form.deviceType == '99') ? _c('div', [_c('el-input', {
    staticClass: "input-form",
    attrs: {
      "placeholder": "请输入设备型号",
      "size": "mini"
    },
    model: {
      value: (_vm.form.otherDeviceType),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherDeviceType", $$v)
      },
      expression: "form.otherDeviceType"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.subCatalogId != '1010700' && _vm.subCatalogId != '1010410' && _vm.subCatalogId != '1010510') ? _c('div', {
    key: _vm.renovate,
    staticClass: "order-input-wrap"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "170px"
    }
  }, [_c('base-tag', {
    staticClass: "param-info",
    attrs: {
      "label": "参数信息"
    }
  })], 1)]), _vm._v(" "), (_vm.isShowTemplate) ? _c('div', {
    staticStyle: {
      "margin-left": "55px",
      "margin-top": "10px"
    },
    style: (_vm.subCatalogId == '1010698' || _vm.subCatalogId == '1010699' ? 'position: absolute;top: 40px;left:578px;' : '')
  }, [_c('span', [_vm._v("使用模版")]), _vm._v(" "), _c('el-select', {
    ref: "select",
    staticStyle: {
      "width": "186px",
      "margin-left": "45px",
      "margin-bottom": "13px"
    },
    attrs: {
      "size": "small",
      "placeholder": "使用模版"
    },
    on: {
      "change": function($event) {
        return _vm.changeTemplate()
      }
    },
    model: {
      value: (_vm.templateItem),
      callback: function($$v) {
        _vm.templateItem = $$v
      },
      expression: "templateItem"
    }
  }, [_vm._l((_vm.templateOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "label": item.title,
        "value": item.id
      }
    }, [_c('span', {
      staticClass: "toLeft"
    }, [_vm._v(_vm._s(item.title) + " ")]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.id != '9999'),
        expression: "item.id != '9999'"
      }],
      staticClass: "toRight"
    }, [_c('span', {
      staticClass: "toLeft",
      on: {
        "click": function($event) {
          return _vm.updateItem(item.id)
        }
      }
    }, [_c('span', {
      staticClass: "editText"
    }, [_vm._v("编辑")])]), _vm._v(" "), _c('span', {
      staticClass: "toRight",
      on: {
        "click": function($event) {
          return _vm.removeTemplateItem(item.id)
        }
      }
    }, [_c('span', {
      staticClass: "removeText"
    }, [_vm._v("删除")])])])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "auto",
      "height": "34px",
      "line-height": "34px"
    }
  }, [_c('a', {
    staticStyle: {
      "margin-left": "30px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createTempate.apply(null, arguments)
      }
    }
  }, [_vm._v("生成模版")])])], 2), _vm._v(" "), (['2010120', '2010210', '2010220', '2010320', '2010420', '1010120'].includes(_vm.subCatalogId) && ['0', ''].includes(_vm.withServCataId)) ? _c('span', {
    staticStyle: {
      "margin-left": "90px"
    }
  }, [_vm._v("\n              设计软件")]) : _vm._e(), _vm._v(" "), (!['1010698', '1010699'].includes(_vm.subCatalogId) && ['2010120', '2010210', '2010220', '2010320', '2010420', '1010120'].includes(_vm.subCatalogId) && ['0', ''].includes(_vm.withServCataId)) ? _c('el-select', {
    ref: "select",
    staticStyle: {
      "width": "186px",
      "margin-left": "45px",
      "margin-bottom": "13px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.changeSoftware
    },
    model: {
      value: (_vm.designSoftware),
      callback: function($$v) {
        _vm.designSoftware = $$v
      },
      expression: "designSoftware"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "通用",
      "value": "00"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "exocad",
      "value": "10"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.polymerization && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-polymerization"
  }, [_vm._m(7), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorPolymerization': _vm.colorPolymerization
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.polymerization),
      "unit": "度",
      "step": Number(1),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumPolymerization
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.baseHeight && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-baseHeight"
  }, [_vm._m(8), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorBaseHeight': _vm.colorBaseHeight
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.baseHeight),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": _vm.editNumBaseHeight
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.shoulderWidth && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-shoulderWidth"
  }, [_vm._m(9), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorShoulderWidth': _vm.colorShoulderWidth
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.shoulderWidth),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumShoulderWidth
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.shoulderAngle && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-shoulderAngle"
  }, [_vm._m(10), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorShoulderAngle': _vm.colorShoulderAngle
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.shoulderAngle),
      "unit": "度",
      "step": Number(1),
      "limit": Number(150)
    },
    on: {
      "edit-num": _vm.editNumShoulderAngle
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.polymerization && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-select-input shoulder"
  }, [_vm._m(11), _vm._v(" "), _c('el-radio', {
    staticClass: "givging",
    attrs: {
      "label": "01"
    },
    model: {
      value: (_vm.form.gingiva),
      callback: function($$v) {
        _vm.$set(_vm.form, "gingiva", $$v)
      },
      expression: "form.gingiva"
    }
  }, [_vm._v("龈下")]), _vm._v(" "), _c('el-radio', {
    staticClass: "givging",
    attrs: {
      "label": "02"
    },
    model: {
      value: (_vm.form.gingiva),
      callback: function($$v) {
        _vm.$set(_vm.form, "gingiva", $$v)
      },
      expression: "form.gingiva"
    }
  }, [_vm._v("齐龈")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "03"
    },
    model: {
      value: (_vm.form.gingiva),
      callback: function($$v) {
        _vm.$set(_vm.form, "gingiva", $$v)
      },
      expression: "form.gingiva"
    }
  }, [_vm._v("龈上")])], 1) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '1010210' || _vm.subCatalogId == '1010220') ? _c('div', {
    staticClass: "input-form-wrap",
    staticStyle: {
      "width": "210px",
      "margin-left": "-30px"
    }
  }, [_c('div', {
    staticClass: "el-input-supragingival"
  }, [(_vm.form.gingiva == '01' || _vm.form.gingiva == '03') ? _c('input-num', {
    style: ({
      '--inputColorSupragingival': _vm.colorSupragingival
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.supragingival),
      "step": Number(0.5),
      "limit": Number(3)
    },
    on: {
      "edit-num": _vm.editNumSupragingival
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '1010698' || _vm.subCatalogId == '1010699') ? _c('div', {
    staticClass: "params-top"
  }, [_c('div', {
    staticClass: "input-form-wrap"
  }, [_vm._m(12), _vm._v(" "), _c('el-select', {
    staticClass: "input-select",
    attrs: {
      "placeholder": "请选择设备型号",
      "size": "mini"
    },
    on: {
      "change": function($event) {
        return _vm.changeDeviceType()
      }
    },
    model: {
      value: (_vm.form.deviceType),
      callback: function($$v) {
        _vm.$set(_vm.form, "deviceType", $$v)
      },
      expression: "form.deviceType"
    }
  }, _vm._l((_vm.devicelists), function(item) {
    return _c('el-option', {
      key: item.value,
      staticClass: "option-item",
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.form.deviceType == '99') ? _c('div', [_c('el-input', {
    staticClass: "input-form",
    attrs: {
      "placeholder": "请输入设备型号",
      "size": "mini"
    },
    model: {
      value: (_vm.form.otherDeviceType),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherDeviceType", $$v)
      },
      expression: "form.otherDeviceType"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.selectDeviceData.plateThickness || _vm.plateZero) ? _c('div', {
    staticClass: "input-form-wrap plate-param el-input-plateThickness"
  }, [_vm._m(13), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorPlateThickness': _vm.colorPlateThickness
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.plateThickness),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumThickness
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '1010698' || _vm.subCatalogId == '1010699') ? _c('div', {
    staticClass: "input-form-wrap params-null-box"
  }) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.teethModelDeviation || _vm.plateZero) ? _c('div', {
    staticClass: "input-form-wrap plate-param el-input-teethModel"
  }, [_vm._m(14), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorTeethModel': _vm.colorTeethModelDeviation
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.teethModelDeviation),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumTeethModelDeviation
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.teethModelDeviation || _vm.plateZero) ? _c('div', {
    staticClass: "input-form-wrap plate-param el-input-recessedRetention"
  }, [_vm._m(15), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorRecessedRetention': _vm.colorRecessedRetentionAmount
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.recessedRetentionAmount),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumRecessedRetentionAmount
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '1010698' || _vm.subCatalogId == '1010699') ? _c('div', {
    staticClass: "input-form-wrap params-null-box"
  }) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.guideRingCompensatio || _vm.plateZero) ? _c('div', {
    staticClass: "input-form-wrap plate-param el-input-theGuideRing"
  }, [_vm._m(16), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorTheGuideRing': _vm.colorGuideRingCompensatio
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.guideRingCompensatio),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumGuideRingCompensatio
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.selectDeviceData.adhesiveGap && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-adhesivegap"
  }, [_vm._m(17), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAdhesiveGap': _vm.colorAdhesiveGap
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.adhesiveGap),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumAdhesivegap
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.adhesiveExtraGap && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-adhesiveExtragap"
  }, [_vm._m(18), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAdhesiveExtraGap': _vm.colorAdhesiveExtraGap
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.adhesiveExtraGap),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumAdhesiveextragap
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.minThick && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-minthick"
  }, [_vm._m(19), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorMinThick': _vm.colorMinThick
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.minThick),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumMinthick
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.wallHeight && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-wallheight"
  }, [_vm._m(20), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorWallHeight': _vm.colorWallHeight
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.wallHeight),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumWallheight
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.edgeLineDistance && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-edgeLinedistance"
  }, [_vm._m(21), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorEdgeLineDistance': _vm.colorEdgeLineDistance
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.edgeLineDistance),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumEdgelinedistance
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.smoothDistance && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-smoothdistance"
  }, [_vm._m(22), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorSmoothDistance': _vm.colorSmoothDistance
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.smoothDistance),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumSmoothdistance
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.burRadius && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-burradius"
  }, [_vm._m(23), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorBurRadius': _vm.colorBurRadius
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.burRadius),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumBurradiusr
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.burGapOffset && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-burgapoffset"
  }, [_vm._m(24), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorBurGapOffset': _vm.colorBurGapOffset
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.burGapOffset),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumBurgapoffset
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.edgeLineOffset && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-edgelineoffset"
  }, [_vm._m(25), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorEdgeLineOffset': _vm.colorEdgeLineOffset
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.edgeLineOffset),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumEdgelineoffset
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.stretchOffset && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-stretchoffset"
  }, [_vm._m(26), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorStretchOffset': _vm.colorStretchOffset
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.stretchOffset),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumStretchoffset
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.angleOffset && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-angleoffset"
  }, [_vm._m(27), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAngleOffset': _vm.colorAngleOffset
    }),
    attrs: {
      "unit": "度",
      "num": Number(_vm.selectDeviceData.angleOffset),
      "step": Number(1),
      "limit": Number(90)
    },
    on: {
      "edit-num": _vm.editNumAngleoffset
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isTonguesideShow && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap"
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "input-radio"
  }, [_c('div', {
    staticClass: "input-radio-box"
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.isTongueSide),
      callback: function($$v) {
        _vm.$set(_vm.form, "isTongueSide", $$v)
      },
      expression: "form.isTongueSide"
    }
  }, [_vm._v("无")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.isTongueSide),
      callback: function($$v) {
        _vm.$set(_vm.form, "isTongueSide", $$v)
      },
      expression: "form.isTongueSide"
    }
  }, [_vm._v("有")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.form.isTongueSide == '1' && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-select-input"
  }, [_vm._m(29), _vm._v(" "), _c('el-select', {
    staticClass: "input-form",
    attrs: {
      "placeholder": "请选择舌侧边补偿参数",
      "size": "mini"
    },
    model: {
      value: (_vm.form.sideOffset),
      callback: function($$v) {
        _vm.$set(_vm.form, "sideOffset", $$v)
      },
      expression: "form.sideOffset"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "舌侧边",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "360度边",
      "value": "1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.tongueSideOffset && _vm.form.isTongueSide == '1' && _vm.form.sideOffset == '0' && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-tonguesideoffset"
  }, [_vm._m(30), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorTongueSideOffset': _vm.colorTongueSideOffset
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.tongueSideOffset),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumTonguesideoffset
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceData.circleSideOffset && _vm.form.isTongueSide == '1' && _vm.form.sideOffset == '1' && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-circlesideoffset"
  }, [_vm._m(31), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorCircleSideOffset': _vm.colorCircleSideOffset
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.circleSideOffset),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumCirclesideoffset
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.selectDeviceData.occlusalClearance || _vm.selectDeviceData.occlusalClearance == 0) && ['1010120', '1010310', '1010320', '2010120', '2010320', '2010420'].includes(_vm.subCatalogId) && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-occlusalClearance"
  }, [_vm._m(32), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorOcclusalClearance': _vm.colorOcclusalClearance
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.occlusalClearance),
      "step": Number(0.001),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumOcclusalClearance
    }
  })], 1) : _vm._e(), _vm._v(" "), ((_vm.selectDeviceData.adjacencyGap || _vm.selectDeviceData.adjacencyGap == 0) && ['1010120', '1010310', '1010320', '2010120', '2010320', '2010420'].includes(_vm.subCatalogId) && _vm.designSoftware == '00') ? _c('div', {
    staticClass: "input-form-wrap el-input-adjacencyGap"
  }, [_vm._m(33), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAdjacencyGap': _vm.colorAdjacencyGap
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.adjacencyGap),
      "step": Number(0.001),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumAdjacencyGap
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-inner"
  }, [_vm._m(34), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorInner': _vm.colorInnerCrownThickness
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.innerCrownThickness),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('innerCrownThickness', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-occlusion"
  }, [_vm._m(35), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorOcclusion': _vm.colorOcclusionSpace
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.occlusionSpace),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('occlusionSpace', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-adhesive"
  }, [_vm._m(36), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAdhesive': _vm.colorAdhesiveThickness
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.adhesiveThickness),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('adhesiveThickness', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-edge-horizontal"
  }, [_vm._m(37), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorEdgeHorizontal': _vm.colorEdgeHorizontalWidth
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.edgeHorizontalWidth),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('edgeHorizontalWidth', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-edge-tilt"
  }, [_vm._m(38), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorEdgeTilt': _vm.colorEdgeTiltWidth
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.edgeTiltWidth),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('edgeTiltWidth', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-edge-inclination"
  }, [_vm._m(39), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorEdgeInclination': _vm.colorEdgeInclinationAngle
    }),
    attrs: {
      "unit": "度",
      "num": Number(_vm.selectDeviceData.edgeInclinationAngle),
      "step": Number(1),
      "limit": Number(90)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('edgeInclinationAngle', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-edge-vertical"
  }, [_vm._m(40), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorEdgeVertical': _vm.colorEdgeVerticalHeight
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.edgeVerticalHeight),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('edgeVerticalHeight', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-top"
  }, [_vm._m(41), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorTop': _vm.colorTopAdhesiveWidth
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.topAdhesiveWidth),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('topAdhesiveWidth', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-axial"
  }, [_vm._m(42), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAxial': _vm.colorAxialExtraClearance
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.axialExtraClearance),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('axialExtraClearance', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-extra"
  }, [_vm._m(43), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorExtra': _vm.colorRadialExtraClearance
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.radialExtraClearance),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('radialExtraClearance', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-sectional"
  }, [_vm._m(44), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorSectional': _vm.colorCrossSectionalAreaConnector
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.crossSectionalAreaConnector),
      "unit": "mm²",
      "step": Number(1),
      "limit": Number(150)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('crossSectionalAreaConnector', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-prohibited"
  }, [_vm._m(45), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorProhibited': _vm.colorProhibitedFillingMargin
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.prohibitedFillingMargin),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('prohibitedFillingMargin', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-gingival"
  }, [_vm._m(46), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorGingival': _vm.colorGingivalThickness
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.gingivalThickness),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('gingivalThickness', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-distance"
  }, [_vm._m(47), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorDistance': _vm.colorDistanceAdjacentTooth
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.distanceAdjacentTooth),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('distanceAdjacentTooth', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-margin-line"
  }, [_vm._m(48), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorMarginLine': _vm.colorMarginLineShift
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.marginLineShift),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('marginLineShift', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-cement"
  }, [_vm._m(49), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorCement': _vm.colorCementGap
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.cementGap),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('cementGap', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-from"
  }, [_vm._m(50), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorFrom': _vm.colorFromMarginLine
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.fromMarginLine),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('fromMarginLine', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designSoftware == '10') ? _c('div', {
    staticClass: "input-form-wrap el-input-margin-cement"
  }, [_vm._m(51), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorMarginCement': _vm.colorMarginCementWidth
    }),
    attrs: {
      "num": Number(_vm.selectDeviceData.marginCementWidth),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": function($event) {
        return _vm.editNum('marginCementWidth', $event)
      }
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.subCatalogId == '1010210' && _vm.withServCataId == '1010220') ||
    (_vm.subCatalogId == '1010220' && _vm.withServCataId == '1010210') ? false : true) ? _c('div', {
    key: _vm.paramKey,
    staticClass: "order-input-wrap"
  }, [(_vm.withServCataId.includes('1010120')) ? _c('base-tag', {
    staticClass: "param-info-hat",
    attrs: {
      "label": "上部修复冠参数信息"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.withServCataId.includes('1010210') || _vm.withServCataId.includes('1010220')) && !_vm.withServCataId.includes('1010120')) ? _c('base-tag', {
    staticClass: "param-info-part",
    attrs: {
      "label": "基台参数信息"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.withServCataId.includes('1010120')) ? _c('div', {
    staticClass: "params-top"
  }, [_c('div', {
    staticClass: "input-form-wrap"
  }, [_vm._m(52), _vm._v(" "), _c('el-select', {
    staticClass: "input-select",
    attrs: {
      "placeholder": "请选择设备型号",
      "size": "mini"
    },
    on: {
      "change": _vm.changeAddeviceType
    },
    model: {
      value: (_vm.form.addeviceType),
      callback: function($$v) {
        _vm.$set(_vm.form, "addeviceType", $$v)
      },
      expression: "form.addeviceType"
    }
  }, _vm._l((_vm.addevicelists), function(item) {
    return _c('el-option', {
      key: item.value,
      staticClass: "option-item",
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.form.addeviceType == '99') ? _c('div', [_c('el-input', {
    staticClass: "input-form",
    attrs: {
      "placeholder": "请输入设备型号",
      "size": "mini"
    },
    model: {
      value: (_vm.form.otherDeviceType),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherDeviceType", $$v)
      },
      expression: "form.otherDeviceType"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.polymerization) ? _c('div', {
    staticClass: "input-form-wrap el-input-polymerization"
  }, [_vm._m(53), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorPolymerization': _vm.colorPolymerization
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.polymerization),
      "unit": "度",
      "step": Number(1),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumPolymerization
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.baseHeight) ? _c('div', {
    staticClass: "input-form-wrap el-input-baseHeight"
  }, [_vm._m(54), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorBaseHeight': _vm.colorBaseHeight
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.baseHeight),
      "step": Number(0.005),
      "limit": Number(13)
    },
    on: {
      "edit-num": _vm.editNumBaseHeight
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.shoulderWidth) ? _c('div', {
    staticClass: "input-form-wrap el-input-shoulderWidth"
  }, [_vm._m(55), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorShoulderWidth': _vm.colorShoulderWidth
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.shoulderWidth),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumShoulderWidth
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.shoulderAngle) ? _c('div', {
    staticClass: "input-form-wrap el-input-shoulderAngle"
  }, [_vm._m(56), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorShoulderAngle': _vm.colorShoulderAngle
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.shoulderAngle),
      "unit": "度",
      "step": Number(1),
      "limit": Number(150)
    },
    on: {
      "edit-num": _vm.editNumShoulderAngle
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.polymerization) ? _c('div', {
    staticClass: "input-form-wrap el-select-input shoulder"
  }, [_vm._m(57), _vm._v(" "), _c('el-radio', {
    staticClass: "givging",
    attrs: {
      "label": "01"
    },
    model: {
      value: (_vm.form.gingiva),
      callback: function($$v) {
        _vm.$set(_vm.form, "gingiva", $$v)
      },
      expression: "form.gingiva"
    }
  }, [_vm._v("龈下")]), _vm._v(" "), _c('el-radio', {
    staticClass: "givging",
    attrs: {
      "label": "02"
    },
    model: {
      value: (_vm.form.gingiva),
      callback: function($$v) {
        _vm.$set(_vm.form, "gingiva", $$v)
      },
      expression: "form.gingiva"
    }
  }, [_vm._v("齐龈")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "03"
    },
    model: {
      value: (_vm.form.gingiva),
      callback: function($$v) {
        _vm.$set(_vm.form, "gingiva", $$v)
      },
      expression: "form.gingiva"
    }
  }, [_vm._v("龈上")])], 1) : _vm._e(), _vm._v(" "), ((_vm.withServCataId.includes('1010210') || _vm.withServCataId.includes('1010220')) && !_vm.withServCataId.includes('1010120')) ? _c('div', {
    staticClass: "input-form-wrap",
    staticStyle: {
      "width": "210px",
      "margin-left": "-30px"
    }
  }, [_c('div', {
    staticClass: "el-input-supragingival"
  }, [(_vm.form.gingiva == '01' || _vm.form.gingiva == '03') ? _c('input-num', {
    style: ({
      '--inputColorSupragingival': _vm.colorSupragingival
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.supragingival),
      "step": Number(0.5),
      "limit": Number(3)
    },
    on: {
      "edit-num": _vm.editNumSupragingival
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.adhesiveGap) ? _c('div', {
    staticClass: "input-form-wrap el-input-adhesivegap"
  }, [_vm._m(58), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAdhesiveGap': _vm.colorAdhesiveGap
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.adhesiveGap),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumAdhesivegap
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.adhesiveExtraGap) ? _c('div', {
    staticClass: "input-form-wrap el-input-adhesiveExtragap"
  }, [_vm._m(59), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAdhesiveExtraGap': _vm.colorAdhesiveExtraGap
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.adhesiveExtraGap),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumAdhesiveextragap
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.minThick) ? _c('div', {
    staticClass: "input-form-wrap el-input-minthick"
  }, [_vm._m(60), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorMinThick': _vm.colorMinThick
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.minThick),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumMinthick
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.wallHeight) ? _c('div', {
    staticClass: "input-form-wrap el-input-wallheight"
  }, [_vm._m(61), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorWallHeight': _vm.colorWallHeight
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.wallHeight),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumWallheight
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.edgeLineDistance) ? _c('div', {
    staticClass: "input-form-wrap el-input-edgeLinedistance"
  }, [_vm._m(62), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorEdgeLineDistance': _vm.colorEdgeLineDistance
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.edgeLineDistance),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumEdgelinedistance
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.smoothDistance) ? _c('div', {
    staticClass: "input-form-wrap el-input-smoothdistance"
  }, [_vm._m(63), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorSmoothDistance': _vm.colorSmoothDistance
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.smoothDistance),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumSmoothdistance
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.burRadius) ? _c('div', {
    staticClass: "input-form-wrap el-input-burradius"
  }, [_vm._m(64), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorBurRadius': _vm.colorBurRadius
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.burRadius),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumBurradiusr
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.burGapOffset) ? _c('div', {
    staticClass: "input-form-wrap el-input-burgapoffset"
  }, [_vm._m(65), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorBurGapOffset': _vm.colorBurGapOffset
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.burGapOffset),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumBurgapoffset
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.edgeLineOffset) ? _c('div', {
    staticClass: "input-form-wrap el-input-edgelineoffset"
  }, [_vm._m(66), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorEdgeLineOffset': _vm.colorEdgeLineOffset
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.edgeLineOffset),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumEdgelineoffset
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.stretchOffset) ? _c('div', {
    staticClass: "input-form-wrap el-input-stretchoffset"
  }, [_vm._m(67), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorStretchOffset': _vm.colorStretchOffset
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.stretchOffset),
      "step": Number(0.005),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumStretchoffset
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.angleOffset) ? _c('div', {
    staticClass: "input-form-wrap el-input-angleoffset"
  }, [_vm._m(68), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAngleOffset': _vm.colorAngleOffset
    }),
    attrs: {
      "unit": "度",
      "num": Number(_vm.selectDeviceDataInfo.angleOffset),
      "step": Number(1),
      "limit": Number(90)
    },
    on: {
      "edit-num": _vm.editNumAngleoffset
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.occlusalClearance) ? _c('div', {
    staticClass: "input-form-wrap el-input-occlusalClearance"
  }, [_vm._m(69), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorOcclusalClearance': _vm.colorOcclusalClearance
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.occlusalClearance),
      "step": Number(0.001),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumOcclusalClearance
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.selectDeviceDataInfo.adjacencyGap) ? _c('div', {
    staticClass: "input-form-wrap el-input-adjacencyGap"
  }, [_vm._m(70), _vm._v(" "), _c('input-num', {
    style: ({
      '--inputColorAdjacencyGap': _vm.colorAdjacencyGap
    }),
    attrs: {
      "num": Number(_vm.selectDeviceDataInfo.adjacencyGap),
      "step": Number(0.001),
      "limit": Number(10)
    },
    on: {
      "edit-num": _vm.editNumAdjacencyGap
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.subCatalogId).isScanData == '1') ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [(this.subCatalogId != '1010410') ? _c('base-tag', {
    attrs: {
      "label": "口扫数据"
    }
  }) : _c('base-tag', {
    attrs: {
      "label": "扫描数据"
    }
  }), _vm._v(" "), (_vm.subCatalogId == '1010698' || _vm.subCatalogId == '1010700') ? _c('div', [_c('span', {
    staticClass: "tip-btn1",
    on: {
      "click": _vm.changeOralDis
    }
  }, [_vm._v("查看示例")]), _vm._v(" "), _c('div', {
    staticClass: "order-upload-wrap"
  }, [_c('div', {
    staticClass: "order-file-wrap"
  }, [_c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "before-upload": _vm.handleChange,
      "http-request": _vm.uploadFile,
      "before-remove": _vm.beforeRemove,
      "on-remove": function (file, fileList) {
        _vm.handleRemove(file, fileList, '07')
      },
      "data": {
        objectType: '07',
        objectTag: _vm.subCatalogId + '_' + _vm.form.demPatient
      },
      "file-list": _vm.dataScan,
      "on-exceed": _vm.handleExceed,
      "auto-upload": true,
      "limit": 5,
      "multiple": "",
      "disabled": _vm.oralUpload
    }
  }, [_c('div', {
    staticClass: "upload-file-dragger1",
    on: {
      "click": _vm.oralTip
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])])], 1)])]) : _c('div', {
    staticClass: "order-upload-wrap"
  }, [_c('div', {
    staticClass: "order-file-wrap"
  }, [_c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "before-upload": _vm.handleChange,
      "http-request": _vm.uploadFile,
      "before-remove": _vm.beforeRemove,
      "on-remove": function (file, fileList) {
        _vm.handleRemove(file, fileList, '07')
      },
      "data": {
        objectType: '07',
        objectTag: _vm.subCatalogId + '_' + _vm.form.demPatient
      },
      "file-list": _vm.dataScan,
      "on-exceed": _vm.handleExceed,
      "auto-upload": true,
      "limit": 5,
      "multiple": ""
    }
  }, [_c('div', {
    staticClass: "upload-file-dragger1"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.subCatalogId).isMouthData == '1') ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "口内照片"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "order-upload-wrap"
  }, [_c('div', {
    staticClass: "order-image-wrap"
  }, [_c('el-upload', {
    staticClass: "upload-demp",
    attrs: {
      "action": "",
      "before-upload": _vm.beforeUpload,
      "http-request": _vm.uploadFile,
      "data": {
        objectType: '09',
        objectTag: _vm.subCatalogId + '_' + _vm.form.demPatient
      },
      "on-preview": _vm.handlePreview,
      "before-remove": _vm.beforeRemove,
      "on-remove": function (file, fileList) {
        _vm.handleRemove(file, fileList, '09')
      },
      "on-exceed": _vm.handleExceed,
      "auto-upload": true,
      "limit": 6,
      "list-type": "picture-card",
      "multiple": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.subCatalogId).isCbctData == '1' && (_vm.subCatalogId == '1010698' || _vm.subCatalogId == '1010699')) ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [(_vm.subCatalogId == '1010698') ? _c('span', {
    class: _vm.subCatalogId == '1010699' ? 'tip-btn3' : 'tip-btn2',
    on: {
      "click": _vm.changeCBCTDis
    }
  }, [_vm._v("查看示例")]) : _c('span', {
    class: _vm.subCatalogId == '1010699' ? 'tip-btn3' : 'tip-btn2',
    on: {
      "click": _vm.changeCBCTDis1
    }
  }, [_vm._v("查看示例")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataCbct.length <= 0),
      expression: "dataCbct.length<=0"
    }],
    class: _vm.fileNum > 0 ? 'load-advice-file' : 'load-advice'
  }, [_vm._v("提示：大于100MBCBCT文件上传时间较长，请耐心等待，建议使用较快本地网络进行操作。")]), _vm._v(" "), (_vm.subCatalogId == '1010698') ? _c('base-tag', {
    attrs: {
      "label": "CBCT数据"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subCatalogId == '1010699') ? _c('base-tag', {
    attrs: {
      "label": "上传患者佩戴放射导板的CBCT数据文件 (DICOM格式)"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-upload-wrap"
  }, [_c('div', {
    staticClass: "order-file-wrap"
  }, [_c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "before-upload": _vm.handleChange,
      "http-request": _vm.uploadFile,
      "before-remove": _vm.beforeRemove,
      "on-remove": function (file, fileList) {
        _vm.handleRemove(file, fileList, '10')
      },
      "data": {
        objectType: '10',
        objectTag: _vm.subCatalogId + '_' + _vm.form.demPatient
      },
      "file-list": _vm.dataCbct,
      "on-exceed": _vm.handleExceed,
      "auto-upload": true,
      "limit": 6,
      "multiple": "",
      "disabled": _vm.subCatalogId == '1010698' ? _vm.CBCTUpload : _vm.CBCTUpload1
    }
  }, [(_vm.subCatalogId == '1010698') ? _c('div', {
    staticClass: "upload-file-dragger1",
    on: {
      "click": function($event) {
        return _vm.CBCT1Tip()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _c('div', {
    staticClass: "upload-file-dragger1",
    on: {
      "click": function($event) {
        return _vm.CBCT2Tip()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.common.serv.get(_vm.subCatalogId).isCbctData == '1' && _vm.subCatalogId == '1010699') ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('span', {
    staticClass: "tip-btn4",
    on: {
      "click": _vm.changeCBCTDis2
    }
  }, [_vm._v("查看示例")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataSheet.length <= 0),
      expression: "dataSheet.length<=0"
    }],
    class: _vm.fileNum > 0 ? 'load-advice-file' : 'load-advice'
  }, [_vm._v("\n            提示：大于100MBCBCT文件上传时间较长，请耐心等待，建议使用较快本地网络进行操作。\n          ")]), _vm._v(" "), _c('base-tag', {
    attrs: {
      "label": "上传放射导板CBCT数据（DICOM格式）"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "order-upload-wrap"
  }, [_c('div', {
    staticClass: "order-file-wrap"
  }, [_c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "before-upload": _vm.handleChange,
      "http-request": _vm.uploadFile,
      "before-remove": _vm.beforeRemove,
      "on-remove": function (file, fileList) {
        _vm.handleRemove(file, fileList, '08')
      },
      "data": {
        objectType: '08',
        objectTag: _vm.subCatalogId + '_' + _vm.form.demPatient
      },
      "file-list": _vm.dataSheet,
      "on-exceed": _vm.handleExceed,
      "auto-upload": true,
      "limit": 6,
      "multiple": "",
      "disabled": _vm.CBCTUpload2
    }
  }, [_c('div', {
    staticClass: "upload-file-dragger1",
    on: {
      "click": function($event) {
        return _vm.CBCT3Tip()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])])], 1)])], 1) : _vm._e(), _vm._v(" "), (['1010210', '1010220', '1010310', '1010320', '1010410', '1010510'].includes(_vm.subCatalogId) || ['1010210', '1010220'].includes(_vm.withServCataId)) ? _c('div', {
    staticClass: "input-upload-wrap"
  }, [_c('base-tag', {
    attrs: {
      "label": "扫描杆和替代体数据库"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "order-upload-wrap"
  }, [_c('div', {
    staticClass: "order-file-wrap"
  }, [_c('el-upload', {
    staticClass: "upload-file",
    attrs: {
      "action": "",
      "before-upload": _vm.handleChange,
      "http-request": _vm.uploadFile,
      "before-remove": _vm.beforeRemove,
      "on-remove": function (file, fileList) {
        _vm.handleRemove(file, fileList, '21')
      },
      "data": {
        objectType: '21',
        objectTag: _vm.subCatalogId + '_' + _vm.form.demPatient
      },
      "file-list": _vm.dataScanRod,
      "on-exceed": _vm.handleExceed,
      "auto-upload": true,
      "limit": 5,
      "multiple": ""
    }
  }, [_c('div', {
    staticClass: "upload-file-dragger1"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])])], 1)])], 1) : _vm._e(), _vm._v(" "), (['1010210', '1010220', '1010310', '1010320', '1010410', '1010510'].includes(_vm.subCatalogId) || ['1010210', '1010220'].includes(_vm.withServCataId)) ? _c('FileHistory', {
    attrs: {
      "dataField": 'dataScanRod'
    },
    on: {
      "push-data": _vm.handleFileList
    }
  }) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "70%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-ops"
  }, [(_vm.currentStep === 2) ? _c('y-button', {
    attrs: {
      "text": "重新创建",
      "classStyle": "main-btn ml"
    },
    on: {
      "btnClick": _vm.clickReSelect
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep === 3) ? _c('y-button', {
    attrs: {
      "text": "上一步",
      "classStyle": "main-btn ml"
    },
    on: {
      "btnClick": _vm.clickPreStep
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStep != 3) ? _c('y-button', {
    attrs: {
      "text": "下一步",
      "classStyle": _vm.nextStep ? 'main-btn ml' : 'disabled-btn ml'
    },
    on: {
      "btnClick": _vm.clickNextStep
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEditServOrder == '1' || _vm.currentStep == 3) ? _c('y-button', {
    attrs: {
      "text": _vm.isEditServOrder == '1' ? '修改提交' : '生成订单',
      "classStyle": _vm.isSubmitting ? 'disabled-btn ml' : 'main-btn ml'
    },
    on: {
      "btnClick": _vm.submitUpdate
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('Customer', {
    staticClass: "customerSer"
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": "",
      "title": "进度留言",
      "width": "30%",
      "visible": _vm.msgDialog,
      "modal-append-to-body": false,
      "destroy-on-close": true,
      "lock-scroll": false
    },
    on: {
      "update:visible": function($event) {
        _vm.msgDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "left",
      "model": _vm.ruleForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "content",
      "label": "留言内容:",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 8
      },
      "placeholder": "请填写留言内容内容"
    },
    model: {
      value: (_vm.ruleForm.content),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "content", $$v)
      },
      expression: "ruleForm.content"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.msgDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("继续制作")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isEditTemplate == '0' ? '创建模版' : '编辑模版',
      "width": "60%",
      "visible": _vm.templateDialog,
      "modal-append-to-body": false,
      "destroy-on-close": true,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.templateDialog = $event
      }
    }
  }, [_c('paramTemplate', {
    key: _vm.templateDialog,
    attrs: {
      "isDevicelistShow": _vm.isDevicelistShow,
      "form": _vm.form,
      "devicelists": _vm.devicelists,
      "camParamList": _vm.camParamList,
      "selectDeviceData": _vm.selectDeviceData,
      "subCatalogId": _vm.subCatalogId,
      "isTonguesideShow": _vm.isTonguesideShow,
      "plateZero": _vm.plateZero,
      "datalists": _vm.datalists,
      "isEditTemplate": _vm.isEditTemplate,
      "editDeviceParam": _vm.editDeviceParam
    },
    on: {
      "changeDialog": _vm.changeDialog,
      "changeDeviceType": _vm.changeDeviceType
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogStatue,
      "width": "40%",
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogStatue = $event
      }
    }
  }, [_c('div', {
    staticClass: "promptWin"
  }, [(_vm.subCatalogId == '1010698' || _vm.subCatalogId == '1010699') ? _c('ul', {
    staticClass: "dialog-ul"
  }, [_c('li', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_vm._v("注：请确认上传的扫描数据具有稳定上下颌咬合关系的全口数字印模，如图参考")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/images/yaohe.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "advice adv-txt"
  }, [_vm._v("咬合")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/images/shanghe.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "advice adv-txt"
  }, [_vm._v("上颌")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/images/xiahe.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "advice adv-txt"
  }, [_vm._v("下颌")])])]) : (_vm.subCatalogId == '1010700') ? _c('ul', {
    staticClass: "dialog-ul"
  }, [_c('li', {
    staticStyle: {
      "width": "520px",
      "margin-bottom": "10px"
    }
  }, [_vm._v("注：按覆盖义齿获取上，下颌全口信息数据，建议传统口内硅胶取模，翻制石膏模型后进行椅旁数字化扫描，上传数字化文件")])]) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.CBCTdialog,
      "width": "40%",
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.CBCTdialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "promptWin"
  }, [_c('ul', {
    staticClass: "dialog-ul"
  }, [_c('li', [_c('p', {
    staticClass: "advice-CBCT"
  }, [_vm._v("a.请确保数据无断层，重要组织解剖结构，如上颌窦，神经管等清晰可见，无伪影，开牙合拍摄，如图参考")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/CBCT1.png"
    }
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "advice-CBCT"
  }, [_vm._v("b.CBCT导出层厚不宜过大，建议层厚＜0.3mm,如图参考")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/CBCT2.png"
    }
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "advice-CBCT"
  }, [_vm._v("c. CBCT视野不小于8*8cm，工作侧拍摄清晰，如图参考")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/CBCT3.png"
    }
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "advice-CBCT"
  }, [_vm._v("d．若口内存在大量不可摘修复体，需要先制作放射导板，并拍摄患者佩戴放射导板的CBCT数据")])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.CBCTdialog1,
      "width": "40%",
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.CBCTdialog1 = $event
      }
    }
  }, [_c('div', {
    staticClass: "promptWin"
  }, [_c('p', {
    staticClass: "prompt",
    staticStyle: {
      "text-align": "center",
      "font-size": "16px",
      "color": "black"
    }
  }, [_vm._v("注：患者佩戴咬合记录和放射导板拍摄CBCT,确认放射导板就位密贴。")]), _vm._v(" "), _c('ul', {
    staticClass: "dialog-ul"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": "/static/images/order/catalog_adv/occlusion.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "advice adv-txt"
  }, [_vm._v("口内佩戴咬合记录和放射导板")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/images/order/catalog_adv/radiate.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "advice adv-txt"
  }, [_vm._v("拍摄佩戴放射导板的CBCT")])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.CBCTdialog2,
      "width": "40%",
      "modal-append-to-body": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.CBCTdialog2 = $event
      }
    }
  }, [_c('div', {
    staticClass: "promptWin"
  }, [_c('p', {
    staticClass: "prompt",
    staticStyle: {
      "text-align": "center",
      "font-size": "16px",
      "color": "black"
    }
  }, [_vm._v("注：上颌放射导板组织面朝上拍摄，下颌放射导板咬合面朝上拍摄。")]), _vm._v(" "), _c('ul', {
    staticClass: "dialog-ul"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": "/static/images/order/catalog_adv/upperRadiate.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "advice adv-txt"
  }, [_vm._v("上颌放射导板")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/images/order/catalog_adv/lowerRadiate.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "advice adv-txt"
  }, [_vm._v("下颌放射导板")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("修复体材质")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label",
    staticStyle: {
      "margin-left": "-5%"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("冠部是否开孔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label",
    staticStyle: {
      "margin-left": "4.5%"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("手术器械盒供应商")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("导环规格和型号：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("数据类型")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("扫描仪品牌")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("CAM制造设备名称")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("聚合度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("基台不低于")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("肩台宽度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("肩台角度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("肩台与牙龈位置")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("CAM制造设备名称")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("导板厚度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("牙齿/模型偏移")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("倒凹保留量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("从导环的补偿")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("黏着剂间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("额外黏着剂间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("最小厚度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("壁高度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("到边缘线的距离")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("平滑距离")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("车针半径")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("车针补偿间距")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘线补偿")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("延伸补偿")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("补偿角度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("舌侧边补偿(宽度)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("舌侧边补偿参数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("舌侧边")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("360度边")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("咬合间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("邻接间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("内冠厚度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("咬合空间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("粘接剂厚度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘水平宽度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘倾斜宽度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘倾斜角度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘垂直高度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("顶部粘接剂宽度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("轴向额外间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("径向额外间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("连接杆横截面积")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("禁止填除边缘")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("牙龈厚度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("到邻牙距离")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘线下移")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("粘接间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("从边缘线")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘粘接剂宽度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("CAM制造设备名称")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("聚合度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("基台不低于")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("肩台宽度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("肩台角度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("肩台与牙龈位置")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("黏着剂间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("额外黏着剂间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("最小厚度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("壁高度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("到边缘线的距离")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("平滑距离")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("车针半径")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("车针补偿间距")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("边缘线补偿")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("延伸补偿")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("补偿角度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("咬合间隙")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-label"
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("邻接间隙")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57393d25","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/orderCreate.vue
// module id = 647
// module chunks = 0